import React from "react";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "./EventDetails.css";
import "swiper/css/autoplay";
import { useTranslation } from "react-i18next";

const EventDetails = ({ sponsers }) => {
  const { t, i18n } = useTranslation();
  const swiper = useSwiper();

  const EventDetails = [
    { title: t("home.participant"), count: "66+" },
    { title: t("home.workshop"), count: "13+" },
    { title: t("home.speaker"), count: "50+" },
    { title: t("home.participant"), count: "66+" },
    { title: t("home.workshop"), count: "13+" },
    { title: t("home.speaker"), count: "50+" },
  ];

  return (
    <section className="category container">
      <Swiper
        keyboard={true}
        mousewheel={true}
        className="Swiper"
        modules={[Navigation, Autoplay]}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        loop={true}
        centeredSlides={true}
        breakpoints={{
          300: {
            slidesPerView: 1.9,
            spaceBetween: 10,
          },
          640: {
            slidesPerView: 1.9,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2.9,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3.9,
            spaceBetween: 30,
          },
        }}
        grabCursor={true}
        freeMode={true}
        freeModeMomentum={false}
        allowTouchMove={false}
        autoplay={{
          delay: 0,
          disableOnInteraction: false,
          reverseDirection: true,
        }}
        speed={2000}
      >
        {EventDetails.map((item, i) => (
          <SwiperSlide
            key={i}
            style={{
              color:
                item?.count == "66+"
                  ? "#4aa6d3"
                  : item?.count == "13+"
                  ? "#319694"
                  : item?.count == "50+"
                  ? "#808080"
                  : "",
              textAlign: "center",
            }}
          >
            <div className="text-7xl font-semibold text-center">
              {item?.count}
            </div>
            <div className="text-xl mt-3 tracking-wide text-center">
              {item?.title}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default EventDetails;
